import Component from 'components/pages/Partners/Partners.qmee';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('partners');
export default buildPage(Component, {
  requiresAuthentication: false,
  metaData: {
    title: 'Partners',
    description: 'Partners Page',
  },
});
